/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetInvoiceIssuerOptionDto
 */
export interface GetInvoiceIssuerOptionDto {
    /**
     * 
     * @type {string}
     * @memberof GetInvoiceIssuerOptionDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetInvoiceIssuerOptionDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetInvoiceIssuerOptionDto
     */
    nip?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetInvoiceIssuerOptionDto
     */
    isDefault: boolean;
}

/**
 * Check if a given object implements the GetInvoiceIssuerOptionDto interface.
 */
export function instanceOfGetInvoiceIssuerOptionDto(value: object): value is GetInvoiceIssuerOptionDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('isDefault' in value) || value['isDefault'] === undefined) return false;
    return true;
}

export function GetInvoiceIssuerOptionDtoFromJSON(json: any): GetInvoiceIssuerOptionDto {
    return GetInvoiceIssuerOptionDtoFromJSONTyped(json, false);
}

export function GetInvoiceIssuerOptionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetInvoiceIssuerOptionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'nip': json['nip'] == null ? undefined : json['nip'],
        'isDefault': json['isDefault'],
    };
}

export function GetInvoiceIssuerOptionDtoToJSON(value?: GetInvoiceIssuerOptionDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'nip': value['nip'],
        'isDefault': value['isDefault'],
    };
}

